import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Radar, User, Lock, Loader2, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Giriş başarılı");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-backdrop flex items-center justify-center p-4">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-11 w-11 rounded-md bg-blue-600 flex items-center justify-center">
            <Radar className="h-6 w-6 text-white" strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold tracking-tight text-lg">GPS-Vehiclize</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Otomasyon Paneli</div>
          </div>
        </div>

        <div className="border border-zinc-800 bg-zinc-900/60 rounded-md p-6">
          <h1 className="font-heading text-xl font-bold mb-1">Giriş Yap</h1>
          <p className="text-xs text-zinc-500 mb-6">Devam etmek için hesap bilgilerinizi girin.</p>

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-[11px] uppercase tracking-wider text-zinc-400">Kullanıcı Adı</Label>
              <div className="relative">
                <User className="h-4 w-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input
                  data-testid="login-username"
                  className="bg-zinc-950 border-zinc-700 focus:ring-blue-500 focus:border-blue-500 rounded pl-9"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  autoFocus
                />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label className="text-[11px] uppercase tracking-wider text-zinc-400">Şifre</Label>
              <div className="relative">
                <Lock className="h-4 w-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input
                  data-testid="login-password"
                  type="password"
                  className="bg-zinc-950 border-zinc-700 focus:ring-blue-500 focus:border-blue-500 rounded pl-9"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white active:scale-95"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (<>Giriş Yap <ArrowRight className="h-4 w-4 ml-1.5" /></>)}
            </Button>
          </form>
        </div>
        <p className="text-center text-[11px] text-zinc-600 mt-4 font-mono">GPS-Vehiclize · TransferZ Otomasyon</p>
      </div>
    </div>
  );
}
